import { WebFsError } from '#common/types';
export class InvalidFsEntryIdError extends WebFsError {
    constructor() {
        super('Invalid file system entry ID!');
    }
}
export class NotFoundError extends WebFsError {
    constructor(message = 'File not found!') {
        super(message);
    }
}
export class AlreadyExistsError extends WebFsError {
    constructor(message = 'Entry already exists!') {
        super(message);
    }
}
export class DirNotEmptyError extends WebFsError {
    constructor(message = 'Directory not empty!', devDetails) {
        super(message, devDetails);
    }
}
export class FileReadOnlyError extends WebFsError {
    constructor(message = 'The file is read-only.') {
        super(message);
    }
}
export class HardLinkTargetNotSupportedError extends WebFsError {
    constructor(message = 'Hard links are only supported for files.', devDetails) {
        super(message, devDetails);
    }
}
